<template>
  <div>
    <unit-items v-for="(item, index) in params" :key="`component-${index}`" v-model="item.model" :name="params.question"/>
    <pre>
      {{doc}}
    </pre>
  </div>
</template>

<script>
// @ is an alias to /src
import { UnitItems } from "@/components/units";

export default {
  name: "ArchitectureComponents",
  data() {
    return {
      doc: this.value
    };
  },
  watch: {
    doc: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.doc = val;
    },
  },
  components: {
    UnitItems 
  },
  props: {
    params: Array,
    value: Array
  },
};
</script>
